// src/utils/storage.js
// Centralized localStorage/sessionStorage access with typed helpers

const STORAGE_KEYS = {
  TOKEN: 'token',
  RESTAURANT_ID: 'restaurantId',
  ROLE: 'role',
  QR: 'qr',
  ORDER_MODE: 'orderMode',
  VENUE_ID: 'venueId',
  CURRENT_ORDER_ID: 'currentOrderId',
  CURRENT_VENUE_ORDER_ID: 'currentVenueOrderId',
  TABLE_ID: 'tableId',
  TABLE_NAME: 'tableName',
  TABLE_IDENTIFIER: 'tableIdentifier',
  RESTAURANT_NAME: 'restaurantName',
};

export const storage = {
  getToken: () => localStorage.getItem(STORAGE_KEYS.TOKEN),
  setToken: (token) => localStorage.setItem(STORAGE_KEYS.TOKEN, token),
  clearToken: () => localStorage.removeItem(STORAGE_KEYS.TOKEN),

  getRestaurantId: () => localStorage.getItem(STORAGE_KEYS.RESTAURANT_ID),
  setRestaurantId: (id) => localStorage.setItem(STORAGE_KEYS.RESTAURANT_ID, id),

  getRole: () => localStorage.getItem(STORAGE_KEYS.ROLE),
  setRole: (role) => localStorage.setItem(STORAGE_KEYS.ROLE, role),

  getOrderMode: () => sessionStorage.getItem(STORAGE_KEYS.ORDER_MODE),
  setOrderMode: (mode) => sessionStorage.setItem(STORAGE_KEYS.ORDER_MODE, mode),

  getQR: () => sessionStorage.getItem(STORAGE_KEYS.QR),
  setQR: (value) => sessionStorage.setItem(STORAGE_KEYS.QR, value),

  getVenueId: () => sessionStorage.getItem(STORAGE_KEYS.VENUE_ID),
  setVenueId: (id) => sessionStorage.setItem(STORAGE_KEYS.VENUE_ID, id),

  getCurrentOrderId: () =>
    sessionStorage.getItem(STORAGE_KEYS.CURRENT_ORDER_ID),
  setCurrentOrderId: (id) =>
    sessionStorage.setItem(STORAGE_KEYS.CURRENT_ORDER_ID, id),
  clearCurrentOrderId: () =>
    sessionStorage.removeItem(STORAGE_KEYS.CURRENT_ORDER_ID),

  getCurrentVenueOrderId: () =>
    sessionStorage.getItem(STORAGE_KEYS.CURRENT_VENUE_ORDER_ID),
  setCurrentVenueOrderId: (id) =>
    sessionStorage.setItem(STORAGE_KEYS.CURRENT_VENUE_ORDER_ID, id),

  getTableId: () => sessionStorage.getItem(STORAGE_KEYS.TABLE_ID),
  setTableId: (id) => sessionStorage.setItem(STORAGE_KEYS.TABLE_ID, id),

  getTableName: () => sessionStorage.getItem(STORAGE_KEYS.TABLE_NAME),
  setTableName: (name) => sessionStorage.setItem(STORAGE_KEYS.TABLE_NAME, name),

  getTableIdentifier: () =>
    sessionStorage.getItem(STORAGE_KEYS.TABLE_IDENTIFIER),
  setTableIdentifier: (id) =>
    sessionStorage.setItem(STORAGE_KEYS.TABLE_IDENTIFIER, id),

  getSessionRestaurantId: () =>
    sessionStorage.getItem(STORAGE_KEYS.RESTAURANT_ID),
  setSessionRestaurantId: (id) =>
    sessionStorage.setItem(STORAGE_KEYS.RESTAURANT_ID, id),

  getRestaurantName: () => localStorage.getItem(STORAGE_KEYS.RESTAURANT_NAME),
  setRestaurantName: (name) =>
    localStorage.setItem(STORAGE_KEYS.RESTAURANT_NAME, name),

  clearAuth: () => {
    localStorage.removeItem(STORAGE_KEYS.TOKEN);
    localStorage.removeItem(STORAGE_KEYS.ROLE);
  },

  clearSession: () => {
    Object.values(STORAGE_KEYS).forEach((key) => {
      sessionStorage.removeItem(key);
    });
  },
};

export { STORAGE_KEYS };
